import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ModulosService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodosModulo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          modulo {
            obtenerTodos(paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  categoria_modulo_codigo
                  nombre
                  activado
                  fecha_creacion
                  endpoint
                  orden
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.modulo.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerModulosSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: moduloInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          modulo {
            obtenerModulosSegunFiltro(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  categoria_modulo_codigo
                  categoria_modulo_nombre
                  nombre
                  activado
                  fecha_creacion
                  endpoint
                  orden
                  habilitar_bloqueo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.modulo.obtenerModulosSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    modificar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: moduloInputType) {
          modulo {
            modificar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                categoria_modulo_codigo
                nombre
                activado
                fecha_creacion
                endpoint
                orden
                habilitar_bloqueo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.modulo.modificar;
            callback({ mensajes, respuesta });
        });
    }
}
ModulosService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModulosService_Factory() { return new ModulosService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ModulosService, providedIn: "root" });
